import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function createData(indicator, value) {
  return {indicator, value};
}

const table1 = [
  createData('Market Cap', '$3.54T'),
  createData('Revenue (TTM)', '$385.60B'),
  createData('Net Income (TTM)', '$101.96B'),
  createData('5Yr Avg Net Income', '$88.32B'),
  createData('P/E (TTM)', '34.71'),
  createData('5Yr P/E', '40.07'),
  createData('PS Ratio', '9.18'),
  createData('Profit Margin (TTM)', '26.44%'),
  createData('5Yr Profit Margin', '24.83%'),
  createData('Gross Profit Margin (TTM)', '45.96%'),
  createData('3Yr Compound Rev Growth', '3.56%'),
  createData('5Yr Compound Rev Growth', '8.28%'),
  createData('10Yr Compound Rev Growth', '8.03%')
];

const table2 = [
  createData('Free Cash Flow (TTM)', '$104.34B'),
  createData('5Yr Avg FCF', '$95.88B'),
  createData('Price/FCF (TTM)', '33.92'),
  createData('5Yr Avg Price/FCF', '36.91'),
  createData('Dividend Yield (TTM)', '0.43%'),
  createData('Dividends Paid', '$15.19B'),
  createData('Forward Dividend Yield', '0.43%'),
  createData('Enterprise Value', '$3.78T'),
  createData('EV/Earnings', '36.70'),
  createData('EV/FCF', '35.87'),
  createData('EV/5Yr Earnings', '42.37'),
  createData('EV/5Yr FCF', '39.03')
];

const table3 = [
  createData('Return on Assets', '29.66%'),
  createData('Return on Equity', '152.84%'),
  createData('Return on Inv Capital (TTM)', '55.79%'),
  createData('5Yr Return on Inv Capital', '44.98%'),
  createData('5Yr Book Value CAGR', '-7.11%'),
  createData('10Yr Book Value CAGR', '-5.78%')
];

const table4 = [
  createData('52 WK High (10/15/24)', '$237.49'),
  createData('52 WK Low (04/19/24)', '$163.67'),
  createData('ATH (10/15/24)', '$237.49'),
  createData('25 Day MA', '$229.34'),
  createData('50 Day MA', '$226.67'),
  createData('100 Day MA', '$221.42'),
  createData('200 Day MA', '$200.54')
];


function DenseTable({ data }) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));



  return (
    <TableContainer component={Paper} elevation={2} sx={{ minWidth: isMobile ? '88vw' : '20vw' }}>
      <Table sx={{  }} size="small" aria-label="a dense table">
        <TableBody>
          {data.map((row) => (
            <TableRow
              key={row.indicator}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}    //delete last child th?
            >
              <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                {row.indicator}
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}



export default function KeyIndicatorsTables() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  return (
    <Box sx={{
      marginLeft: isMobile ? '0.5rem' : '3rem',
      marginRight: isMobile ? '0.5rem' : '3rem',
      // margin: 'auto',
      marginTop: isMobile ? '1.5rem' : '2.5rem',
      marginBottom: '5rem',
      justifyContent: 'center',
      }}>
      <Grid container rowSpacing={3} columnSpacing={6} justifyContent={'center'}>
        <Grid >
          <DenseTable data={table1} ></DenseTable>
        </Grid>
        <Grid >
          <DenseTable data={table2}></DenseTable>
        </Grid>
        <Grid >
          <DenseTable data={table3}></DenseTable>
        </Grid>
        <Grid >
          <DenseTable data={table4}></DenseTable>
        </Grid>
      </Grid>
    </Box>
  )
}
